export default __webpack_public_path__ + "static/media/Rose-Cake.6a35eadf.jpg";